import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import Home from './pages/Home'

const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const QuoteForm = lazy(() => import('./components/forms/QuoteForm'))
const Rice = lazy(() => import('./pages/products/Rice'))
const Pulses = lazy(() => import('./pages/products/Pulses'))
const Spices = lazy(() => import('./pages/products/Spices'))
const CattleFeed = lazy(() => import('./pages/products/CattleFeed'))
const Cereal = lazy(() => import('./pages/products/Ceral'))
const BecomePartner = lazy(() => import('./pages/BecomePartner'))

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Suspense fallback={<div className="flex items-center justify-center py-32 text-gray-400">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/get-quote" element={<QuoteForm />} />
              <Route path="/products/rice" element={<Rice />} />
              <Route path="/products/pulses" element={<Pulses />} />
              <Route path="/products/spices" element={<Spices />} />
              <Route path="/products/cereals" element={<Cereal />} />
              <Route path="/products/cattle-feed" element={<CattleFeed />} />
              <Route path="/become-partner" element={<BecomePartner />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
